import { AxiosInstance, AxiosStatic } from 'axios'
import { ApiRoutesNames } from 'bets.oddprovider.lib.common.ts/api/routes'
import { IUser } from 'bets.oddprovider.lib.common.ts/models'
import { BaseApiClient } from 'fwork-jsts-common/src/apiClient'
import { FilterQuery } from 'mongoose'
import { store } from '../redux/store'

export class UsersApiClient extends BaseApiClient<IUser, any, FilterQuery<IUser>, IUser, IUser> {
  constructor(axios: AxiosStatic | AxiosInstance) {
    const dotEnvProductionState = store.getState().dotEnvProductionState
    const baseUrl = `${dotEnvProductionState.payload?.APIURL}${ApiRoutesNames.users}`
    super({
      apiUrl: baseUrl,
      axios,
    })
  }
}